<template>
    <div class="card">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th v-sort:name>Название</th>
                        <th v-sort:count class="text-nowrap">
                            <div class="d-none d-lg-inline">Кол-во продуктов</div>
                            <div class="d-inline d-lg-none">Кол-во</div>
                        </th>

                        <th class="action-buttons" />
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="planogram in planograms" :key="planogram.id">
                        <td class="truncate">{{ planogram.name }}</td>
                        <td>{{ planogram.layout.length }} шт</td>

                        <td class="action-buttons">
                            <router-link :to="{ name: 'stocks.planograms.show', params: { id: planogram.id }}" class="btn btn-icon btn-edit" />
                            <button type="button" class="btn btn-icon btn-remove" @click.prevent="remove(planogram.id)" />
                        </td>
                    </tr>
                </tbody>

                <tfoot v-if="noOne" class="no-one">
                    <tr>
                        <td colspan="42">Вы пока не добавили ни одной планограммы.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="noFound" class="no-one">
                    <tr>
                        <td colspan="42">По вашему запросу не найдено ни одной планограммы.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="meta.last_page > 1">
                    <tr>
                        <td colspan="42">
                            <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'

import store from '@/store'
import { toastSuccess, toastError, confirm } from '@/dialogs'

export default {
    components: {
        Pagination
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        planograms() {
            return this.$store.state.planograms.data || []
        },

        meta() {
            return this.$store.state.planograms.meta || {}
        },

        noOne() {
            return this.planograms.length === 0 && !this.filter.search
        },

        noFound() {
            return this.planograms.length === 0 && this.filter.search
        }
    },

    methods: {
        async remove(id) {
            if (!await confirm('Вы уверены, что хотите удалить?')) {
                return
            }

            let done = await this.$store.dispatch('planograms/remove', id)

            done
                ? toastSuccess('Удалено')
                : toastError('Ошибка')
        }
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch('planograms/fetchAll', to.query)
        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await store.dispatch('planograms/fetchAll', to.query)
        next()
    }
}
</script>
